<template>
  <div class="nowrap">
    <a class="data-table-action"
       :title="$t('payment')"
       v-b-tooltip.hover
       @click="salaryPressed">
      <DollarSvg/>
    </a>
    <a class="data-table-action ml-2"
       :title="$t('refresh')"
       v-b-tooltip.hover
       @click="recalculate">
      <RefreshSvg class=""/>
    </a>
    <a class="data-table-action ml-2"
       v-if="object.paid > 0"
       :title="$t('cancel')"
       v-b-tooltip.hover
       @click="deletePayment">
      <BackSvg/>
    </a>
    <a class="data-table-action ml-2"
       :title="$t('print')"
       v-b-tooltip.hover
       @click="printStatement">
      <PrintSvg/>
    </a>
  </div>
</template>

<script>

import DollarSvg from '@/assets/svg-vue/accounting/dollar.svg'
import BackSvg from '@/assets/svg-vue/accounting/back.svg'
import RefreshSvg from '@/assets/svg-vue/general/refresh2.svg'
import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import {mapState} from "vuex"
import { AccountingService } from "@/services/api/accounting.api.service"
import JwtService from "@/services/jwt.service"


export default {
  name: "AccountingMonthDatatableTDSalariesAction",
  components: {
    DollarSvg,
    BackSvg,
    PrintSvg,
    RefreshSvg
  },
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      accountingmonth: state => state.accounting.accountingmonth,
      clinic: state => state.auth.clinic,
      superadmin: state => state.auth.superadmin,
    }),
  },
  methods: {
    async salaryPressed() {
      this.$store.commit('setSalaryRow', this.copyObject(this.object))
      await this.$nextTick()
      this.$bvModal.show('accounting-salary-modal')
    },
    deletePayment() {
      if(confirm(this.$t('are_you_sure_you_want_to_delete'))) {
        AccountingService.clearSalaryPayments(this.accountingmonth.id, this.object.user_id).then(() => {
          this.$noty.info(this.$t('success_message'))
          this.$store.commit('incrementDataTableCounter')
        })
      }
    },
    async recalculate() {
      const res = await AccountingService.recountUserSalary(this.accountingmonth.id, this.object.user_id)
      if(res.data) {
        this.$noty.info(this.$t('success_message'))
        this.$store.commit('incrementDataTableCounter')
      }
    },
    printStatement() {
      let link = JwtService.getPrintPrelink(this.clinic, this.superadmin)
      link = `${link}/salarySlip/${this.object.user_id}/${this.accountingmonth.id}`
      if(this.superadmin) {
        link = link + `?superadmin_clinic_id=${this.clinic?.id || ''}`
      }
      window.open(link, '_blank')
    }
  }
}
</script>
